import ResourceDetail from "@/src/pages/resource-detail";

export default function CurrentAffairsDetailPage() {
  return <ResourceDetail type="current_affairs" backTo="/current-affairs" label="Current Affairs" />;
}

